import {Injectable} from '@angular/core';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable, of} from 'rxjs';
import {AuthComponent} from 'projects/paid/src/app/components/auth/auth.component';
import {DataService} from 'projects/firebase/src/lib/services/data.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService {
    constructor(
        public auth: AuthService,
        public data: DataService,
        public router: Router,
        private modalService: NgbModal,
    ) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.auth.isLoggedIn || this.openAuthModal(state.url);
    }

    openAuthModal(url: string): Promise<boolean> {
        const modalRef = this.modalService.open(AuthComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });

        // Pass data to modal if needed
        modalRef.componentInstance.data = { redirectUrl: url };

        return new Promise<boolean>((resolve) => {
            modalRef.result
                .then((result: boolean) => {
                    if (result) {
                        // after successful login, redirect to stored url
                        this.router.navigateByUrl(url);
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
                .catch(() => {
                    // modal dismissed
                    resolve(false);
                });
        });
    }

}
